// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-title[data-v-5ef17544]{display:inline-block;font-size:0.16rem;font-weight:700;color:#333;padding-bottom:0.12rem;border-bottom:0.03rem solid #e31d33}.termsIframe[data-v-5ef17544]{width:100%;height:58vh}.content[data-v-5ef17544]{height:4.8rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
